import {scrollToTarget} from './scrolling';

const pageClass = 'pageflow-page';
const navClass = 'pageflow-nav';

const initialState = {
	root: undefined,
	pages: [],
	currentPage: undefined,
	initialised: false,
	prevButton: undefined,
	nextButton: undefined,
	pageTriggers: [],
	navIndicators: [],
}

const PageFlow = (() => {
	const p = initialState;

	p.init = function () {

		const pages = Array.from(document.querySelectorAll(`.${pageClass}[data-pageflow-page]`));
		if (!pages.length) {
			return;
		}

		p.pages = pages.map(page => {
			return {
				id: page.getAttribute('data-pageflow-page'),
				element: page,
				reqFields: page.querySelectorAll('.form-row.validate-required'),
			}
		});

		// Set required field to actually required
		p.pages.forEach((page) => {
			page.reqFields.forEach((field) => {
				field.querySelector('input, textarea, select').setAttribute('required', true);
			});
		});

		// Check last page for valid fields on submit
		const checkout_form = $('form.checkout');
		checkout_form.on('checkout_place_order', (e) => {
			const valid = p.checkPageValidity(p.pages[pages.length - 1]);
			if (valid) {
				return true;
			}

			window.scrollTo({
				top: 0,
				behavior: 'smooth',
			});
			return false;
		});

		p.initNav();

		const pageTriggers = Array.from(document.querySelectorAll('[data-pageflow-target]'));
		if (pageTriggers.length) {
			p.pageTriggers = pageTriggers;
			p._initPageTriggers();
		}

		p.initialised = true;

		const firstPageIndex = p.pages[0].id;
		p.jumpTo(firstPageIndex);
	}

	p._initPageTriggers = function() {
		if (p.pageTriggers && p.pageTriggers.length) {
			p.pageTriggers.forEach(trigger => {
				trigger.addEventListener('click', p.onPageTrigger);
			});
		}
	}

	p._unloadPageTriggers = function() {
		if (p.pageTriggers && p.pageTriggers.length) {
			p.pageTriggers.forEach(trigger => {
				trigger.removeEventListener('click', p.onPageTrigger);
			});
		}
	}

	p.checkPageValidity = function(page) {
		let valid = true;

		// If that page has required fields
		if (page.reqFields) {
			page.reqFields.forEach((field) => {
				const fieldError = field.querySelector('.form-row__error');

				// If field is in ship to different address checkbox
				const shippingFields = field.closest('.woocommerce-shipping-fields');
				if (shippingFields) {
					const shippingFieldsCheckbox = shippingFields.querySelector('#ship-to-different-address-checkbox');
					if (!shippingFieldsCheckbox.checked) {
						return;
					}
				}

				if (!field.querySelector('input, textarea, select').checkValidity()) {
					if (!fieldError) {
						const node = document.createElement('div');
						const textnode = document.createTextNode('Please complete this field');
						node.appendChild(textnode);
						node.classList.add('form-row__error');
						field.appendChild(node);
						field.classList.add('form-row--error');
					}

					valid = false;
				} else if (fieldError) {
					fieldError.remove();
					field.classList.remove('form-row--error');
				}
			});
		}

		return valid;
	}

	p.onPageTrigger = function(e) {
		const triggeredPageId = e.target.getAttribute('data-pageflow-target');

		const currentPage = e.target.closest('[data-pageflow-page]');
		if (currentPage) {
			const el = p.pages.filter((page) => page.element == currentPage);

			const valid = p.checkPageValidity(el[0]);

			//e.preventDefault();
			//e.stopPropagation();
			if (valid) {
				p.jumpTo(triggeredPageId);
			} else {
				window.scrollTo({
					top: 0,
					behavior: 'smooth',
				});
			}
		}
	}

	p.jumpTo = function (requestedPageId) {
		if (!p.initialised) {
			console.log('not initialised')
			return;
		}

		const triggeredPageIndex = p._getPageIndex(requestedPageId);
		if (triggeredPageIndex < 0) {
			return;
		}

		scrollToTarget(document.body); // scroll to top

		const delayForSmoothScroll = 60;

		setTimeout(() => {
			p.pages.forEach((page, index) => {
				if (index === triggeredPageIndex) {
					p._activatePage(page.element);
				}
				else {
					p._deactivatePage(page.element);
				}
			});

			p.currentPage = requestedPageId;
			p.updateNavIndicators();
		}, delayForSmoothScroll);
	}

	// TODO: move this to a separate module, to be instantiated here
	p.initNav = function() {
		const nav = document.querySelector(`.${navClass}`);
		if (!nav || !p.pages.length) {
			return;
		}

		const listFragment = document.createDocumentFragment();
		const list = document.createElement('div');
		list.classList.add(`${navClass}__items`);
		listFragment.appendChild(list);

		const indicators = [];
		p.pages.forEach((page, index) => {
			const item = document.createElement('div');
			item.classList.add(`${navClass}__item`);
			item.setAttribute('data-pageflow-indicator', page.id);
			item.innerHTML = page.id;

			indicators.push(item);
			list.appendChild(item);

			const isLast = index === p.pages.length - 1;
			if (!isLast) {
				const separator = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
				separator.setAttribute('class', `${navClass}__item-separator`);
				separator.setAttribute('width', 6);
				separator.setAttribute('viewBox', '0 0 11 21');
				const icon = document.createElementNS('http://www.w3.org/2000/svg', 'use');
				icon.setAttributeNS('http://www.w3.org/1999/xlink', 'xlink:href', '#rarr');

				separator.appendChild(icon);
				list.appendChild(separator);

			}
		});

		p.navIndicators = indicators;

		const navInner = nav.querySelector('.inner-wrapper');
		if (navInner) {

			while (navInner.firstChild) {
				navInner.removeChild(navInner.firstChild);
			}

			navInner.appendChild(listFragment);
		}
	}

	p.updateNavIndicators = function() {
		//console.log('current page', p.currentPage)
		const currentPageIndex = p._getPageIndex(p.currentPage);
		if (currentPageIndex < 0) {
			return;
		}

		p.navIndicators.forEach((indicator, index) => {
			if (index === currentPageIndex) {
				indicator.classList.add(`${navClass}__item--current`);
			} else {
				indicator.classList.remove(`${navClass}__item--current`);
			}
		});
	}

	/**
	 * Has same return as Array.findIndex
	 *
	 *
	 * @param page element
	 * @returns int
	 */
	p._getPageIndex = function (id) {
		const index = p.pages.findIndex(page => page.id === id);

		return index;
	}

	p._activatePage = function(page) {
		page.classList.add(`${pageClass}--current`);
	}

	p._deactivatePage = function(page) {
		page.classList.remove(`${pageClass}--current`);
	}

	p.unload = function() {
		// TODO
	}

	return p;
})();

export default PageFlow;



// WEBPACK FOOTER //
// ./scripts/modules/page-flow.js